class SubcaseStateChangeModalController {
  /* @ngInject */
  constructor($uibModalInstance, $http, data) {
    this.$uibModalInstance = $uibModalInstance;
    this.$http = $http;
    this.subCase = data.subCase;
  }

  $onInit() {
    this.data = {
      subCaseId: this.subCase.id,
      caseId: this.subCase.case_id,
      state: this.subCase.CurrentSubCaseState.state,
      comment: '',
    };
  }

  submit(form) {
    if (form.$invalid || this.submitting) return;

    if (this.stateFile) {
      this.data.file = this.stateFile;
    }

    this.submitting = true;

    this.$http.put(`/subCase/${this.data.subCaseId}/state`, this.data)
      .then(() => this.reload())
      .catch(() => (this.submitting = false));
  }

  reload() {
    this.submitting = false;
    this.$uibModalInstance.close();
  }
}

export default SubcaseStateChangeModalController;



// WEBPACK FOOTER //
// ./client/components/subcase-state-change-modal/subcase-state-change-modal.js